import React, { useContext, useEffect } from 'react'
import { AppContext } from '@state/context'
import { openPanel } from '@state/actions/panelsActions'
import {
  PANELS,
  BUTTON_TYPE,
  BUTTON_SIZE,
  CONTAINER_STYLE,
  HEADING_TYPE,
  TEXT_SIZES,
  DIVIDER_SIZE,
  SCHOOL_RESOURCE_TYPES,
} from '@helpers/constants'
import SubHeader from '@views/SubHeader'
import Container from '@components/Container'
import Heading from '@components/Heading'
import Divider from '@components/Divider'
import Button from '@components/Button'
import Text from '@components/Text'
import Loader from '@components/Loader'
import { useSchoolGroups } from '@hooks/useSchoolGroups'
import { useCurrentUser } from '@hooks/useCurrentUser'
import SchoolResourceList from '@components/SchoolResourceList'
import { useUserSchoolClasses } from '@hooks/useUserSchoolClasses'
import { useDemoResources } from '@hooks/useDemoResources'
import withTooltip from '@components/WithTooltip'

const ButtonWithTooltip = withTooltip(Button)

const MyTeachersRoom = () => {
  const [, dispatch] = useContext(AppContext)
  const { currentUser } = useCurrentUser()
  const { schoolClasses, error: schoolClassesError, isLoading: loadingSchoolClasses } = useUserSchoolClasses()
  const { schoolGroups, error: schoolGroupsError, isLoading: loadingSchoolGroups } = useSchoolGroups()
  const { demoSchoolClasses, demoSchoolGroups, error: demoSchoolClassesError, isLoading: loadingDemoSchoolClasses } = useDemoResources({ connected: true })

  // useEffect(() => {
  //   if (currentUser?.hasValidPubAgreement && currentUser?.schoolClasses?.length > 1 && schoolClasses?.length > 1 && schoolClasses?.some(sc => sc.isPrivate)) {
  //     dispatch(openPanel(PANELS.MIGRATE_MY_SCHOOL_CLASS))
  //   }
  // }, [currentUser, schoolClasses])

  const school = currentUser?.schools?.[0]

  return (
    <>
      <SubHeader>
        <SubHeader.MiddleSection>
          <ButtonWithTooltip
            type={BUTTON_TYPE.DARK_DARK_GREY}
            size={BUTTON_SIZE.MEDIUM}
            icon={'PlusCircle'}
            iconLeft
            margin
            handleClick={() => {
              dispatch(openPanel(PANELS.ADD_SCHOOL_CLASS))
            }}
            tooltip={
              currentUser?.hasPaidLicense
                ? undefined
                : 'I denna kostnadsfria version av Doklet ingår en (1) klass.'
            }
          >
            Lägg till klass
          </ButtonWithTooltip>

          <ButtonWithTooltip
            type={BUTTON_TYPE.DARK_DARK_GREY}
            size={BUTTON_SIZE.MEDIUM}
            icon={'PlusCircle'}
            iconLeft
            margin
            handleClick={() => {
              dispatch(openPanel(PANELS.CREATE_SCHOOL_GROUP))
            }}
            tooltip='Dela in elever i nivågrupper.'
          >
            Skapa grupp
          </ButtonWithTooltip>
        </SubHeader.MiddleSection>
        <SubHeader.RightSection></SubHeader.RightSection>
      </SubHeader>

      <Container size={CONTAINER_STYLE.DESKTOP}>
        <div className={'flex justify-center'}>
          <Heading headingLevel={HEADING_TYPE.H1} size={TEXT_SIZES.XXLARGE}>
            Mitt lärarrum {school?.name ? '- ' + school.name : ''}
          </Heading>
        </div>

        <Divider size={DIVIDER_SIZE.BASE} />

        <Heading headingLevel={HEADING_TYPE.H2} size={TEXT_SIZES.XLARGE}>
          Klasser
        </Heading>

        <Divider size={DIVIDER_SIZE.SMALL} />

        {loadingSchoolClasses && <Loader />}
        {schoolClassesError && (
          <Text>Någonting gick fel när vi skulle hämta klasser</Text>
        )}
        {!loadingSchoolClasses && !demoSchoolClasses?.length && !schoolClasses.length && (
          <Text>Kunde inte hitta några klasser</Text>
        )}

        {schoolClasses &&
          <SchoolResourceList
            items={schoolClasses}
            demoItems={demoSchoolClasses}
            resourceType={SCHOOL_RESOURCE_TYPES.CLASS}
          />
        }

        <Divider size={DIVIDER_SIZE.MEDIUM} />

        <Heading headingLevel={HEADING_TYPE.H2} size={TEXT_SIZES.XLARGE}>
          Grupper
        </Heading>

        <Divider size={DIVIDER_SIZE.SMALL} />

        {loadingSchoolGroups && <Loader />}
        {schoolGroupsError && (
          <Text>Någonting gick fel när vi skulle hämta grupper</Text>
        )}
        {!loadingSchoolGroups && !demoSchoolGroups?.length && !schoolGroups.length && (
          <Text>Kunde inte hitta några grupper</Text>
        )}

        {schoolGroups && (
          <SchoolResourceList
            items={schoolGroups}
            demoItems={demoSchoolGroups}
            resourceType={SCHOOL_RESOURCE_TYPES.GROUP}
          />
        )}

        <Divider size={DIVIDER_SIZE.MEDIUM} />

      </Container>
    </>
  )
}

export default MyTeachersRoom
